"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = install;

function install() {
  var stage = arguments[0] === undefined ? Infinity : arguments[0];

  if (!global.hasOwnProperty("AudioContext") && global.hasOwnProperty("webkitAudioContext")) {
    global.AudioContext = global.webkitAudioContext;
  }

  if (!global.hasOwnProperty("OfflineAudioContext") && global.hasOwnProperty("webkitOfflineAudioContext")) {
    global.OfflineAudioContext = global.webkitOfflineAudioContext;
  }

  if (!global.AudioContext) {
    return;
  }

  require("./AnalyserNode").install(stage);

  require("./AudioBuffer").install(stage);

  require("./AudioNode").install(stage);

  require("./AudioContext").install(stage);
}

module.exports = exports["default"];